export default {
  C: "C",
  CSharp: "C♯",
  D: "D",
  DFlat: "D♭",
  DSharp: "D♯",
  E: "E",
  EFlat: "E♭",
  F: "F",
  FSharp: "F♯",
  G: "G",
  GFlat: "G♭",
  GSharp: "G♯",
  A: "A",
  AFlat: "A♭",
  ASharp: "A♯",
  B: "B",
  BFlat: "B♭",

  correctExcl: "正解!",
  wrongExcl: "不正解",

  ABORT: "中止",

  lastRound: "以前のラウンド",
  score: "得点",
  accuracy: "正解率",
  correct: "個 正解",
  wrong: "個 不正解",

  START: "スタート",
  settings: "設定",
  ROUND_LENGTH: "ラウンドの長さ",
  NOTE_INPUT: "入力方式",
  CLEF: "音部記号",
  DIFFICULTY: "難易度",
  ACCIDENTALS: "変化記号",
  LANGUAGE: "言語",
  twentySeconds: "20秒",
  oneMinute: "1分",
  fiveMinutes: "5分",
  infinite: "無限",
  buttons: "ボタン",
  piano: "ピアノ",
  trebleClef: "トレブル",
  bassClef: "バス",
  altoClef: "アルト",
  tenorClef: "テノール",
  easy: "易",
  normal: "中",
  hard: "難",
  none: "なし",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ & ♭",
  SOUND: "音声",
  VIBRATION: "振動",
  DISPLAYCORRECTNOTE: "正しい音符を表示する",
  on: "有",
  off: "無",

  TIME: "時間",
  CORRECT: "正解",
  ACCURACY: "正解率",
  SCORE: "得点",

  record: "最高得点",
  history: "履歴",

  noMidiSupport: "機器はMIDIに対応しないようです。",
  noDeviceFound: "MIDI機器が見つかりません。再接続してみてください。",
  playTheNote: "MIDIキーボードで音符を入力してください。",
  lastNotePlayed: "入力した音符",
};



// WEBPACK FOOTER //
// ./src/resources/ja.js